module.exports = __webpack_public_path__ + "static/4-3474e050e0a9a1015ec0b79fff105d94.jpg";